import "./Footer.css";

const EMAIL = "info@maneconsultancy.be";

const SOCIAL_LINKS = [
  {
    id: "email",
    label: "Email Mane Consultancy",
    href: `mailto:${EMAIL}`,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient
            id="footer-grad-email"
            x1="0"
            y1="0"
            x2="24"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#38bdf8" />
            <stop offset="60%" stopColor="#a78bfa" />
            <stop offset="100%" stopColor="#f472b6" />
          </linearGradient>
        </defs>
        <rect
          x="2"
          y="4"
          width="20"
          height="16"
          rx="2.5"
          stroke="url(#footer-grad-email)"
          strokeWidth="1.6"
        />
        <path
          d="M2 8l10 7 10-7"
          stroke="url(#footer-grad-email)"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/mane-consultancy/",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient
            id="footer-grad-linkedin"
            x1="0"
            y1="0"
            x2="24"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#38bdf8" />
            <stop offset="60%" stopColor="#a78bfa" />
            <stop offset="100%" stopColor="#f472b6" />
          </linearGradient>
        </defs>
        <path
          d="M7.25 10v6.75"
          stroke="url(#footer-grad-linkedin)"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M11.75 16.75V10"
          stroke="url(#footer-grad-linkedin)"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
        <path
          d="M11.75 12.75a3 3 0 0 1 6 0v4"
          stroke="url(#footer-grad-linkedin)"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="7.25" cy="7" r="1.25" fill="url(#footer-grad-linkedin)" />
        <rect
          x="2.25"
          y="2.25"
          width="19.5"
          height="19.5"
          rx="4.5"
          stroke="url(#footer-grad-linkedin)"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },
  {
    id: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/maneconsultancy/",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient
            id="footer-grad-facebook"
            x1="0"
            y1="0"
            x2="24"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#38bdf8" />
            <stop offset="60%" stopColor="#a78bfa" />
            <stop offset="100%" stopColor="#f472b6" />
          </linearGradient>
        </defs>
        <path
          d="M13.25 20v-5.5h2.25l.45-2.75h-2.7V9.9a1.35 1.35 0 0 1 1.35-1.35h1.6V6.25h-2.05A3.9 3.9 0 0 0 10.25 10v1.75H8.5v2.75h1.75V20"
          stroke="url(#footer-grad-facebook)"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="2.25"
          y="2.25"
          width="19.5"
          height="19.5"
          rx="4.5"
          stroke="url(#footer-grad-facebook)"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },
  {
    id: "github",
    label: "GitHub",
    href: "https://github.com/mane-consultancy",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient
            id="footer-grad-github"
            x1="0"
            y1="0"
            x2="24"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#38bdf8" />
            <stop offset="60%" stopColor="#a78bfa" />
            <stop offset="100%" stopColor="#f472b6" />
          </linearGradient>
        </defs>
        <path
          d="M9.25 18.6c-3.8 1.15-3.8-1.9-5.35-2.25"
          stroke="url(#footer-grad-github)"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.75 18.6v-2.75a2.4 2.4 0 0 0-.7-1.85c2.35-.25 4.8-1.15 4.8-5.15a4 4 0 0 0-1.1-2.8 3.7 3.7 0 0 0-.05-2.8s-.9-.3-2.95 1.1a10.3 10.3 0 0 0-5.5 0C7.2 2.95 6.3 3.25 6.3 3.25a3.7 3.7 0 0 0-.05 2.8 4 4 0 0 0-1.1 2.8c0 3.95 2.4 4.9 4.75 5.15a2.4 2.4 0 0 0-.65 1.85v2.75"
          stroke="url(#footer-grad-github)"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <p className="site-footer__copyright">© 2026 Mane Consultancy</p>

        <div className="site-footer__socials" aria-label="Social links">
          {SOCIAL_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className="site-footer__icon-link"
              aria-label={link.label}
              target={link.id === "email" ? undefined : "_blank"}
              rel={link.id === "email" ? undefined : "noreferrer"}
            >
              {link.icon}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
